import { render } from "./MiniProductList.vue?vue&type=template&id=7442d804&scoped=true"
import script from "./MiniProductList.vue?vue&type=script&lang=js"
export * from "./MiniProductList.vue?vue&type=script&lang=js"

import "./MiniProductList.vue?vue&type=style&index=0&id=7442d804&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7442d804"]])

export default __exports__